export const CUSTOMER_CREATION_SOURCES = [
  "CUSTOMER_DIRECTORY",
  "DTOOLS_REVIEW",
  "PROPOSAL_UPLOAD",
  "PROPOSAL_BUILDER",
  "SERVICE_VISIT",
  "CALENDAR",
  "REPAIR_ORDER",
  "PROJECT",
  "CLUB_BOOKING",
  "IMPORT",
  "API",
  "OTHER",
  "LEGACY",
  "UNKNOWN",
] as const;

export type CustomerCreationSource = (typeof CUSTOMER_CREATION_SOURCES)[number];

export function isCustomerCreationSource(value: string | null | undefined): value is CustomerCreationSource {
  return CUSTOMER_CREATION_SOURCES.includes(String(value) as CustomerCreationSource);
}

export function formatCustomerCreationSource(value: string | null | undefined): string {
  if (!value) return "Unknown";
  return value
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
